import { RefObject } from 'react';
import { AnimatedModalStatus, Button, Dialog, FormLabel, Radio } from '@screentone/core';

import { useNewsletterTypes } from 'features/newsletters/hooks/useNewsletterTypes';
import { useConvertedProperty } from 'hooks';

interface NewsletterSelectDialogProps {
  open: boolean;
  closeModal: () => void;
  renderNode: HTMLElement;
  handleCancelClick: () => void;
  handleBeginCampaignClick: () => void;
  setSelectedNewsletterId: (id: string) => void;
  status: AnimatedModalStatus;
  selectedNewsletterId: string;
  componentRef: RefObject<HTMLElement>;
}

export const NewsletterSelectDialog = ({
  open,
  closeModal,
  componentRef,
  renderNode,
  handleCancelClick,
  handleBeginCampaignClick,
  status,
  setSelectedNewsletterId,
  selectedNewsletterId
}: NewsletterSelectDialogProps) => {
  const currentProperty = useConvertedProperty();

  const { newsletterTypes } = useNewsletterTypes({
    publicationKey: currentProperty ?? ''
  });

  return (
    <>
      {open && (
        <Dialog
          aria-labelledby="dialogTitle"
          aria-describedby="dialogDesc"
          onDismiss={closeModal}
          renderNode={renderNode}
          status={status}
          ref={componentRef}
        >
          <Dialog.Title id="dialogTitle" data-testid="newsletter-choose-title">
            Choose Newsletter
          </Dialog.Title>
          <Dialog.Content id="dialogDesc">
            {newsletterTypes?.map((newsletterItem) => (
              <div key={newsletterItem.id}>
                <FormLabel label={newsletterItem.name} labelPosition="right" data-testid="newsletter-options-label">
                  <Radio
                    checked={newsletterItem.id === selectedNewsletterId}
                    id={newsletterItem.id}
                    name={newsletterItem.id}
                    onChange={(evt: React.ChangeEvent<HTMLInputElement>) => setSelectedNewsletterId(evt.target.id)}
                    data-testid="newsletter-options-radio"
                  />
                </FormLabel>
              </div>
            ))}
          </Dialog.Content>
          <Dialog.Actions>
            <Button secondary onClick={handleCancelClick} data-testid="newsletter-cancel">
              Cancel
            </Button>
            <Button primary onClick={handleBeginCampaignClick} data-testid="newsletter-begin-campaign">
              Begin Campaign
            </Button>
          </Dialog.Actions>
        </Dialog>
      )}
    </>
  );
};
